import React from "react"
import { Navigate, Outlet, useLocation } from "react-router"
import { useAtomValue } from "jotai"
import { AccessCode, accessStatusAtom, hasAccess, permissionsAtom } from "@store/authAtoms"

export const ProtectedOutlet = () => {
  const authStatus = useAtomValue(accessStatusAtom)
  const permissions = useAtomValue(permissionsAtom)
  const location = useLocation()
  // TODO michal.s navigate back if user doesn't have permission
  if (authStatus.code !== AccessCode.UNAUTHORIZED && !hasAccess(permissions, location.pathname)) {
    return <Navigate to={"/forbidden"} />
  } else if (authStatus.code === AccessCode.UNAUTHORIZED) {
    return <Navigate to={"/denied"} />
  }
  return <Outlet />
}
